import { createSelector } from 'reselect';
import { arrayToObject } from 'utils/helpers';
import { ReducerState, FeatureFlag, FractionalFlag } from './types';

type ReduxState = {
  baus: {
    featureFlags: ReducerState;
  };
};

export const featureFlagsSelector = (state: ReduxState) => state.baus.featureFlags;
export const getUsers = (state: ReduxState) => featureFlagsSelector(state).users;
export const getChangeLog = (state: ReduxState) => featureFlagsSelector(state).changeLog;
export const getFeatureFlags = (state: ReduxState) => featureFlagsSelector(state).featureFlags;
export const getFetching = (state: ReduxState) => featureFlagsSelector(state).fetching;
export const getFetchingChangeLog = (state: ReduxState) =>
  featureFlagsSelector(state).fetchingChangeLog;

export const formatPercentageValues = (values: Record<string, number> = {}) =>
  Object.keys(values).map((value) => ({
    value,
    percentageValue: values[value],
  }));

export const createObjectForFeature = (featureFlag: FeatureFlag) => {
  const { settings, ...otherProps } = featureFlag;
  const { orgIdFractions, projectIdFractions, ...otherSettings } =
    settings as FractionalFlag['settings'];
  return {
    ...otherProps,
    ...otherSettings,
    orgIdFractions: formatPercentageValues(orgIdFractions),
    projectIdFractions: formatPercentageValues(projectIdFractions),
  };
};

export const selectFeatureFlagsObject = createSelector([getFeatureFlags], (featureFlags) => {
  const formatFeatureFlags = featureFlags.map((featureFlag) => createObjectForFeature(featureFlag));
  return arrayToObject(formatFeatureFlags, 'feature');
});

export const selectAdminUsersForFormSelect = createSelector([getUsers], (users) =>
  users.map((user) => ({
    label: `${user.email} - Org Id: ${user.orgId} | ${user.orgName}`,
    value: user,
  })),
);
